import { SupergatorActionTypes } from './supergator.types';

const sso = {
  request: (payload = {}) => ({
    type: SupergatorActionTypes.SSO_EMIT_REQUEST,
    payload,
  }),

  success: () => ({
    type: SupergatorActionTypes.SSO_EMIT_SUCCESS,
    payload: {},
  }),

  failure: error => ({
    type: SupergatorActionTypes.SSO_EMIT_FAILURE,
    payload: { error },
  }),
};

const supergatorActions = {
  sso,
};

export default supergatorActions;
